import React, { Component } from "react";
import Select from "react-select";

export default class FilterDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultValue: this.props.initialValue,
      selectedValue: undefined,
    };
  }

  handleSelect = (event) => {
    this.props.handleSelect(event.value);
  };

  render() {
    return (
      <div className="form-group col-md-6">
        <div>
          <label htmlFor={this.props.htmlFor} className="col-sm-12">
            {this.props.label}
          </label>
        </div>
        <div className="col-sm-10">
          <Select
            options={this.props.dropDownList}
            placeholder={this.props.placeholder}
            onChange={this.handleSelect}
            defaultValue={this.state.defaultValue}
            value={this.state.selectedValue}
            className="react-select-container checkValidate"
            classNamePrefix="react-select"
          />
        </div>
      </div>
    );
  }
}
